import type { JSONSchema, SchemaEnhancerArgs } from '@plone/types';

export const enhancedListingSchema = ({
  schema,
}: SchemaEnhancerArgs): JSONSchema => {

  const schemaProperties = schema.properties as Record<string, any>;

  // headline alignment option
  schemaProperties.headlineAlignment = {
    title: 'Headline alignment',
    type: 'choice',
    choices: [
      ['left', 'Left'],
      ['center', 'Center'],
      ['right', 'Right'],
    ],
    default: 'center',
  };

  // option to display a rule underneath the headline
  schemaProperties.addRule = {
    title: 'Add rule',
    type: 'boolean',
    default: true,
  };

  // add fields underneath "Headline level" field
  const headlineTagIndex = schema.fieldsets[0].fields.indexOf('headlineTag');
  if (headlineTagIndex !== -1) {
    schema.fieldsets[0].fields.splice(headlineTagIndex + 1, 0, 'headlineAlignment');
    schema.fieldsets[0].fields.splice(headlineTagIndex + 2, 0, 'addRule');
  } else {
    schema.fieldsets[0].fields.push('headlineAlignment', 'addRule');
  }

  return schema;
};